(ns ui.error-alert
  "Allows the UI to show an `error` message at the bottom of the app for 5 seconds.")

(defn alert
  [state]
  (when-let [message (::message state)]
    [:div
     {:class
      "z-50 fixed bottom-0 w-full p-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
      :role "alert"
      }
     [:span {:class "font-medium"}
      message]]))

(defn show-error
  "Shows the `error` message at the bottom of the app for 5 seconds."
  [{:keys [error store]}]
  (let [error (or error
                  (do (js/console.warn "show-error called without error message")
                      "Something went wrong. Please try again."))]
    (swap! store
           assoc
           ::message
           error)
    (js/setTimeout (fn []
                     (swap! store
                            update
                            ::message
                            (fn [message]
                              (if (= message error)
                                nil
                                message))))
                   5000)))
